import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=6e10a354"
import script from "./Period.vue?vue&type=script&lang=ts"
export * from "./Period.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports